<template>
    <div class="mainBody">
        <el-button type="primary" size="mini" style="margin-bottom: 10px;position: relative;left: 10px" @click="appendRoot">添加根机构</el-button>
        <div class="abc">
            <el-tree :data="orgData" node-key="id" default-expand-all :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span>
                        <el-button type="text" size="mini" @click="() => append(data)">添加子机构</el-button>
                        <el-button type="text" size="mini" @click="() => edit(node, data)">编辑</el-button>
                        <el-button type="text" size="mini" @click="() => remove(node, data)"> 删除</el-button>
                    </span>
                </span>
            </el-tree>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :pid="pid"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
    </div>
</template>
<script>
import Edit from "./edit";
import listutil from "@/libs/listutil";
import { getOrgTreeData } from '@/api/org'
import { delData } from '@/api/common'

export default {
    name: "orgList",
    mixins: [listutil],
    components: {Edit},
    data(){
        return {
            m_name: '机构',
            menu_id: 1400,
            pid: 0,
            orgData: [],
            list_url: "/api/admin/org/list",
            del_Obj:{
                url:'/api/admin/org/del',
                data:{
                    ids:''
                }
            },
        }
    },
    methods: {
        getData() {
            getOrgTreeData().then(res=>{
                if(res.code == 1){
                    this.orgData = res.data
                }
            })
        },
        appendRoot(){
            this.model_id = -1
            this.pid = 0
            this.edit_title = "添加"+this.m_name
            this.editshow = true
        },
        append(data){
            this.model_id = -1
            this.pid = data.id
            this.edit_title = "添加"+this.m_name
            this.editshow = true
        },
        edit(node, data){
            this.edit_title = "编辑"+this.m_name
            this.model_id = data.id
            this.editshow = true
        },
        remove(node, data){
            this.$confirm('确定要删除该条数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del_Obj.data.ids = data.id
                delData(this.del_Obj).then(res=>{
                    if(res.code ==1){
                        this.$msgs(res.msg)
                        this.getData();
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => {})
        },
        saveOk(){
            this.editshow = false
            this.getData()
        }
    }
}
</script>
<style lang="less">
    .mainBody {
        padding-left: 10px;
        .abc {
            width: 600px;
        }
    }
    .custom-tree-node {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        span {
            font-weight: normal;
        }
    }
</style>